<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="权限名称">
      <el-input v-model="queryParam.name" placeholder="权限名称" />
    </el-form-item>
    <el-form-item label="状态">
      <el-select v-model="queryParam.status" placeholder="权限状态">
        <el-option label="正常" :value="1"/>
        <el-option label="停用" :value="2"/>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button type="danger" @click="getListPerm">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="danger"
          @click="(dialog = true), doPermissionAdd()"
          v-hasPermission="['system:permission']"
          >添加权限</el-button>
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
  <el-table
    :data="filterTableData"
    v-loading="loadingData"
    class="mainTable"
    default-expand-all
    row-key="permissionid"
  >
    <el-table-column label="名称" prop="name" width="200" />
    <el-table-column label="权限" prop="ename" width="250" />
    <el-table-column label="路径" prop="path" width="250" />
    <el-table-column label="类型">
      <template #default="scope">
        <el-tag
          round
          :type="scope.row.nav === 2 ? 'danger' : ''"
          disable-transitions
          ><span v-text="util.showPermissionNav(scope.row.nav)"></span
        ></el-tag>
      </template>
    </el-table-column>
    <el-table-column label="排序" prop="sort" />
    <el-table-column label="图标">
      <template #default="scope">
        <el-icon v-if="scope.row.icon" :size="20">
          <component :is="scope.row.icon"></component>
        </el-icon>
      </template>
    </el-table-column>
    <el-table-column label="状态" prop="status">
      <template #default="scope">
        <el-tag
          round
          :type="scope.row.status === 1 ? 'success' : 'danger'"
          disable-transitions
          ><span v-text="util.showPermissionStaus(scope.row.status)"></span>
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="操作" fixed="right" width="160">
      <template #default="scope">
        <el-link
          type="primary"
          size="small"
          @click="(dialog = true), doPermissionEdit(scope.$index, scope.row)"
          v-hasPermission="['system:permission']"
          >编辑</el-link
        >

        <el-popconfirm
          confirm-button-type="danger"
          confirm-button-text="确定"
          cancel-button-text="取消"
          icon-color="#626AEF"
          title="您确定要删除吗？"
          @confirm="doPermissionDelete(scope.$index, scope.row)"
        >
          <template #reference>
            <el-link
              size="small"
              type="danger"
              v-hasPermission="['system:permission']"
              >删除</el-link
            >
          </template>
        </el-popconfirm>
      </template>
    </el-table-column>
  </el-table>
  </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8"><div>
        <!-- <el-button
          type="danger"
          >添加用户</el-button> -->
      </div></el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          :hide-on-single-page="true"
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[10, 15, 20, 30]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :title="title"
    direction="rtl"
    :close-on-click-modal="false"
    size="45%"
    @close="doPermissionClose"
  >
    <div class="common-drawer__content">
      <el-form
        ref="permFormRef"
        :model="permForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="父栏目">
          <el-tree-select
            style="width: 100%"
            v-model="permForm.parentid"
            :data="tableData"
            check-strictly
            :render-after-expand="false"
            :props="props"
          >
          </el-tree-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input
            v-model.trim="permForm.name"
            placeholder="请输入名称，如系统管理"
          />
        </el-form-item>
        <el-form-item label="权限" prop="ename">
          <el-input
            v-model.trim="permForm.ename"
            placeholder="请输入权限，system:user,system:user:add"
          />
        </el-form-item>
        <el-form-item label="路径" prop="path">
          <el-input
            v-model.trim="permForm.path"
            placeholder="请输入路径，system/user"
          ></el-input>
        </el-form-item>
        <el-form-item label="组件路径" prop="component">
          <el-input
            v-model.trim="permForm.component"
            placeholder="请输入组件路径，system/user"
          ></el-input>
        </el-form-item>
        <el-form-item label="ICON" prop="icon">
          <el-input
            :prefix-icon="Search"
            v-model.trim="permForm.icon"
            placeholder="请选择ICON"
            @click="showIconDialog"
            readonly
          />
        </el-form-item>
        <el-form-item label="类型" prop="nav">
          <el-radio-group v-model="permForm.nav">
            <el-radio :label="1">栏目</el-radio>
            <el-radio :label="3">菜单</el-radio>
            <el-radio :label="2">权限</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="permForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model="permForm.sort"
            :min="0"
            :max="100"
            placeholder="排序值"
          />
        </el-form-item>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doPermissionClose">关闭</el-button>
        <el-button
          type="danger"
          :loading="loading"
          @click="doPermissionSave"
          >{{ loading ? "提交中 ..." : "提交" }}</el-button
        >
      </div>
    </div>
  </el-drawer>

  <icons ref="RefIcon" @click="confirmIcon" />
</template>
  
<script setup>
import { ref, onMounted, computed } from "vue";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import {
  listPermission,
  savePermission,
  deletePermission,
} from "@/api/permission";
import { Search } from "@element-plus/icons-vue";

import Icons from "@/components/common/icons";
import util from "@/util/tool.js";

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const permFormRef = ref();

const total = ref(0);
const pageSize = ref(1000); //每页显示条数

const props = ref({
  checkStrictly: true,
  value: "permissionid",
  label: "name",
});
// const value = ref()

let title = ref("添加权限");

const confirmIcon = (e) => {
  permForm.value.icon = e.value;
};

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: '',
  status: '',
  parentid: '',
});
const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    name: '',
    status: '',
    parentid: '',
  };
  getListPerm();
};

const permForm = ref({
  permissionid: null,
  parentid: null,
  name: '',
  icon: '',
  ename: '',
  path: '',
  component: '',
  sort: 0,
  status: 1,
  nav: 1,
});

const tableData = ref([]);

// const parentDataList = ref([]);
// const parentData = (data) => {
//   let tmpData = data.filter((cdata) => cdata.parentid == 0);

//   let tmpNewData = [];
//   for (let i = 0; i < tmpData.length; i++) {
//     tmpNewData.push({
//       permissionid: tmpData[i].permissionid.toString(),
//       name: tmpData[i].name,
//       ename: tmpData[i].ename,
//     });
//   }
//   return tmpNewData;
// };

const search = ref("");
const filterTableData = computed(() => {
  return tableData.value.filter(
    (data) =>
      !search.value ||
      data.name.toLowerCase().includes(search.value.toLowerCase())
  );
});

const permReset = (perms) => {
  let dataTmp = [];
  perms.forEach((perm) => {
    // console.log(perm);
    perm.permissionid = perm.permissionid.toString();
    perm.parentid = perm.parentid.toString();
    dataTmp.push(perm);
    permReset(perm.children);
  });
  return dataTmp;
};

//ICON选择
let dialogIconVisible = ref(false);
const RefIcon = ref();
const showIconDialog = () => {
  RefIcon.value.changeVisible(!dialogIconVisible.value);
};

//onMounted方法
onMounted(() => {
  getListPerm();
});

const doPermissionAdd = () => {
  title.value = "新增权限";
  resetForm();
  // permFormRef.value.resetFields();
  // permForm.value.permissionid = null;
};

const doPermissionEdit = (index, obj) => {
  title.value = "编辑权限";
  // console.log(obj.nav, obj.name);
  // permForm.value = obj;//直接赋值会出问题
  permForm.value = {
    permissionid: obj.permissionid,
    parentid: obj.parentid ? obj.parentid.toString() : null,
    name: obj.name,
    icon: obj.icon,
    ename: obj.ename,
    path: obj.path,
    component: obj.component,
    sort: obj.sort,
    status: obj.status,
    nav: obj.nav,
  };
};
const doPermissionDelete = (index, obj) => {
  // console.log(obj.permissionid, obj.parentid, obj.name);
  deletePermission(obj).then((res) => {
    // console.log(res);
    if (res.data.code === 1) {
      getListPerm();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

const doPermissionClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  permFormRef.value.resetFields()
};

const resetForm = () => {
  permForm.value = {
    permissionid: null,
    parentid: null,
    name: '',
    icon: '',
    ename: '',
    path: '',
    component: '',
    sort: 0,
    status: 1,
    nav: 1,
  };
};

const doPermissionSave = () => {
  permFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    savePermission(permForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListPerm();
          doPermissionClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//关闭用户表单弹出框
// const doDrawerClose = (done) => {
//   if (loading.value) {
//     return;
//   }
//   ElMessageBox.confirm("您确定要提交表单数据吗？", {
//     distinguishCancelAndClose: true,
//     confirmButtonText: "确定提交",
//     cancelButtonText: "取消",
//   })
//     .then(() => {
//       loading.value = true;
//       timer = setTimeout(() => {
//         done();
//         // 动画关闭需要一定的时间
//         setTimeout(() => {
//           loading.value = false;
//         }, 400);
//       }, 1000);
//     })
//     .catch(() => {
//       // catch error
//     });
// };

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListPerm();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListPerm();
};

//权限表API
const getListPerm = () => {
  listPermission(queryParam.value).then((res) => {
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    // parentDataList.value = parentData(tableData.value);
    //重新封装
    tableData.value = permReset(res.data.extend.pages.list);
    loadingData.value = false
  });
};

//表单验证规则
const rules = ref({
  name: [
    {
      required: true,
      message: "请输入名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 10,
      message: "名称长度2到10",
      trigger: "blur",
    },
  ],
  ename: [
    {
      required: true,
      message: "请输入权限",
      trigger: "blur",
    },
    {
      min: 2,
      max: 50,
      message: "权限长度2到50",
      trigger: "blur",
    },
  ],
});
</script>